import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/codesoil.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Neighborhood2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#codesoil-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Where<span className="purple"> Technology</span> Meets Nature and Community
            </h1>
            <p className="home-about-body">
            Code & Soil is a transformative initiative by Choicest Fruit that blends organic gardening with 
            introductory coding to cultivate <b className="purple">environmental responsibility</b> and <b className="purple">tech development</b>. Designed for
             children, youth, and communities, the program nurtures both hands-on life skills and digital 
             innovation, empowering participants to grow food, write code, and create solutions that benefit
              people and the planet.
            <br />
            <br />By combining the wonders of nature with the power of technology, Code & Soil empowers young 
            people to become digital and environmental problem-solvers. They discover that technology is not
            just about devices, it can be a tool to nurture life, foster sustainability, and strengthen communities.
            <br />
            <br/>
             <h2>What We Do</h2>
                         <br />
                         <li><span className="purple">Hands-On Gardening –</span> From herbs to vegetables and even fruit trees, participants experience the full journey from seed to harvest.</li>
                         <li><span className="purple">Tech Integration –</span> Using tools like Arduino, Raspberry Pi, and coding languages (Python, JavaScript, C++, C#), youth build garden-tech projects such as automated irrigation, growth trackers, and garden websites.</li>
                         <li><span className="purple">Entrepreneurship –</span> Learners design simple online shops, practice budgeting and marketing, and pitch their products,or give back by donating their harvests to neighbors or local charities.</li>
                         <li><span className="purple">Organic Practices –</span> From natural pesticides and compost to soil, seed, and water management, participants learn eco-friendly methods that promote sustainability.</li>
                         <li><span className="purple">Community Engagement –</span> The program encourages sharing knowledge and resources, fostering a sense of community and collective growth.</li>
               
            <br />
            <br /> 
            <h2>Core Learning Outcomes</h2>
                         <br />
                         <li><span className="purple">Eco-Literacy –</span> Understanding soil, water, seeds, pests, and sustainable gardening practices.</li>
                         <li><span className="purple">Digital Skills –</span> Building apps, websites, and automated systems linked to real-world gardening needs.</li>
                         <li><span className="purple">Problem-Solving –</span> Using coding and organic methods to troubleshoot challenges.</li>
                         <li><span className="purple">Collaboration –</span> Working in teams to grow, code, and innovate.</li>
                         <li><span className="purple">Creativity & Innovation –</span> Designing natural solutions and tech prototypes that serve both people and the environment.</li>
                          

            <br />
            <br />
            <h2>Beyond the Garden</h2>
            Code & Soil isn’t just about learning, it’s about community impact. Participants host seasonal 
            Garden-Tech Expos, showcasing their plants, apps, and inventions. Local residents are invited to
             mentor, volunteer, or support children and youth by purchasing products, creating a cycle of service, learning,
              and empowerment that benefits the whole neighborhood.
            <br />
            <br />

          </p>
          <Button onClick={handleClick}>Register Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Neighborhood2;
